export interface LogoInfo {
  image: string;
  name: string;
  descriptionEn: string;
  descriptionFr: string;
}

const logoInfo: LogoInfo[] = [
  {
    image: "react.svg",
    name: "React",
    descriptionEn: "A JavaScript library for building user interfaces",
    descriptionFr: "Une bibliothèque JavaScript pour créer des interfaces utilisateur"
  },
  {
    image: "typescript.svg",
    name: "TypeScript",
    descriptionEn: "A typed superset of JavaScript that compiles to plain JavaScript",
    descriptionFr: "Un sur-ensemble typé de JavaScript qui se compile en JavaScript pur"
  },
  {
    image: "tailwind.svg",
    name: "Tailwind CSS",
    descriptionEn: "A utility-first CSS framework for rapid UI development",
    descriptionFr: "Un framework CSS axé sur l'utilité pour le développement rapide d'interfaces"
  },
  {
    image: "vite.svg",
    name: "Vite",
    descriptionEn: "Next Generation Frontend Tooling",
    descriptionFr: "Outils Frontend de Nouvelle Génération"
  },
  // Add more logos as needed
];

export default logoInfo; 